import React, { useEffect } from 'react'
import {
  BooleanInput,
  Edit,
  FormDataConsumer,
  FormTab,
  required,
  TabbedForm,
  TabbedFormTabs,
  TextInput,
  useEditController,
  useNotify,
  useRedirect,
  useTranslate
} from 'react-admin'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import { Box, CircularProgress, Grid } from '@mui/material'
import { DateTimePickers } from 'src/components/uiElements/react-hook-fields'
import { ArrayInputSector } from './logic/ArrayInputSector'

export const LandingEdit = (props, { id }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const { record, isLoading, isFetching } = useEditController({ resource: 'landing', id })

  useEffect(() => {
    if (record && record.sectors) {
      record.sectors = record.sectors
        .map(elem => ({ ...elem, type: elem.html_content ? 2 : 1 }))
        .sort((a, b) => a.order - b.order)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record])

  const onSuccess = () => {
    notify('ra.notification.updated_success_masculine', {
      type: 'success',
      messageArgs: { element: translate('ra.single_entity.landing') }
    })
    redirect('/landing')
  }

  const onError = () => {
    notify('ra.notification.updated_error_masculine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.landing') }
    })
  }

  const isLoadingTab = (name) => {
    return (
      <Box display={'flex'} alignItems={'center'}>
        <CircularProgress sx={{ marginRight: '5px' }} size={'10px'} />
        {translate(`ra.title.${name}`)}
      </Box>
    )
  }

  return (
    <Edit {...props} mutationMode='pessimistic' mutationOptions={{ onSuccess, onError }} actions={null}>
      <CardCommon title={translate('ra.title.update_landing')}>
        <TabbedForm
          toolbar={<CardCrudBottomButtons btnSave={true} loading={isLoading || isFetching} />}
          tabs={<TabbedFormTabs variant="scrollable" scrollButtons="auto" />}
        >
          <FormTab label={translate('ra.title.general')}>
            <Grid container spacing={3}>
              <EditInputsWrap label={translate('ra.field.id')}>
                <TextInput disabled source='id' label={false} fullWidth />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.short_name')} required>
                <TextInput source='short_name' label={false} fullWidth validate={[required()]} />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.title')} required>
                <TextInput source='title' label={false} fullWidth validate={[required()]} />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.description')}>
                <TextInput source='description' label={false} fullWidth />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.datetime_from')}>
                <DateTimePickers source='datetime_from' />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.datetime_to')}>
                <DateTimePickers source='datetime_to' />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.menu_visible')}>
                <BooleanInput label={translate('ra.field.is_active')} source='menu_visible' fullWidth />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.form_visible')}>
                <BooleanInput label={translate('ra.field.is_active')} source='form_visible' fullWidth />
              </EditInputsWrap>
              <FormDataConsumer>
                {({ formData }) => {
                  return <EditInputsWrap label={translate('ra.field.default_form')}>
                    <TextInput source='default_form' label={false} fullWidth disabled={!formData?.form_visible} />
                  </EditInputsWrap>
                }}
              </FormDataConsumer>
              <EditInputsWrap label={translate('ra.field.newsletter_visible')}>
                <BooleanInput label={translate('ra.field.is_active')} source='newsletter_visible' fullWidth />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.login_required')}>
                <BooleanInput label={translate('ra.field.is_active')} source='login_required' fullWidth />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.index_required')}>
                <BooleanInput label={translate('ra.field.is_active')} source='index_required' fullWidth />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.url')} required>
                <TextInput source='url' label={false} fullWidth validate={[required()]} />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.meta')}>
                <TextInput source='meta' label={false} fullWidth />
              </EditInputsWrap>
            </Grid>
          </FormTab>
          <FormTab
            label={isLoading || isFetching ? isLoadingTab('sectors') : translate('ra.title.sectors')}
            disabled={isLoading || isFetching}
          >
            <Grid container spacing={3}>
              <ArrayInputSector />
            </Grid>
          </FormTab>
        </TabbedForm>
      </CardCommon>
    </Edit>
  )
}